import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {
  Home,
  WaitingAespa,
  WaitingRiize,
  WaitingQueue,
  EnterCode,
  SelectCharacter,
  Play,
  Expired,
} from "../pages";
import {path} from "./path";
import {ARTIST} from "../utils/artist.utils";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={path.home(ARTIST.riize)} replace />}
        />
        <Route path={path.home(ARTIST.riize)} element={<Home />} />
        <Route path={path.home(ARTIST.aespa)} element={<Home />} />
        <Route path={path.waiting(ARTIST.riize)} element={<WaitingRiize />} />
        <Route path={path.waiting(ARTIST.aespa)} element={<WaitingAespa />} />
        <Route
          path={path.waitingQueue(ARTIST.riize)}
          element={<WaitingQueue />}
        />
        <Route
          path={path.waitingQueue(ARTIST.aespa)}
          element={<WaitingQueue />}
        />
        <Route path={path.code(ARTIST.riize)} element={<EnterCode />} />
        <Route path={path.code(ARTIST.aespa)} element={<EnterCode />} />
        <Route
          path={path.character(ARTIST.riize)}
          element={<SelectCharacter />}
        />
        <Route
          path={path.character(ARTIST.aespa)}
          element={<SelectCharacter />}
        />
        <Route path={path.play(ARTIST.riize)} element={<Play />} />
        <Route path={path.play(ARTIST.aespa)} element={<Play />} />
        <Route path={path.expired(ARTIST.riize)} element={<Expired />} />
        <Route path={path.expired(ARTIST.aespa)} element={<Expired />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
